import { BehaviorSubject, ReplaySubject, first } from 'rxjs';

const LOCAL_STORAGE_SELECTED_ORGANIZATION_ID = 'selectedOrganizationId';

export const backendUrlSubject = new ReplaySubject<string>(1);
export const backendUrl = backendUrlSubject.pipe(first());

export const selectedOrganizationIdStore = new BehaviorSubject<string | null>(
  localStorage.getItem(LOCAL_STORAGE_SELECTED_ORGANIZATION_ID) ?? null,
);

selectedOrganizationIdStore.subscribe((selectedOrgId) => {
  if (selectedOrgId != null) {
    localStorage.setItem(LOCAL_STORAGE_SELECTED_ORGANIZATION_ID, selectedOrgId);
  }
});
